module.exports = __webpack_public_path__ + "img/icon-menu-privacy-policy.88f4ba7e.svg";